
import { RequestPaging } from '@/utils/util'
import { Component, Vue } from 'vue-property-decorator'
import LsDialog from '@/components/ls-dialog.vue'
import LsPagination from '@/components/ls-pagination.vue'
import { apiExpressDel, apiExpressLists } from '@/api/setting'
import ExportData from '@/components/export-data/index.vue'
@Component({
    components: {
        LsDialog,
        LsPagination,
        ExportData
    }
})
export default class FreightTemplate extends Vue {
    queryObj = {
        name: ''
    }
    pager = new RequestPaging()
    apiExpressLists = apiExpressLists
    getList(page?: number): void {
        page && (this.pager.page = page)
        this.pager.request({
            callback: apiExpressLists,
            params: {
                ...this.queryObj
            }
        })
    }
    handleReset() {
        this.queryObj = {
            name: ''
        }
        this.getList()
    }
    handleDelete(id: number) {
        apiExpressDel({ id }).then(() => {
            this.getList()
        })
    }

    created() {
        this.getList()
    }
}
